import Vue from 'vue'

function createStore(data, config = {}) {
	let {computed, watch, methods} = config;
	const Store = typeof data == 'function' ? data : Vue.extend({
		data() {
			return data
		},

		computed,

		watch,
		
		methods: {
			...methods,
			commit(key, data) {
				this[key] = data;
			}
		}
	});
	return new Store()
}

function getStore(vm, name = 'store') {
	let store;
	!function loop(vm) {
		if (!vm) return;
		if (vm[name]) {
			store = vm[name];
		} else {
			loop(vm.$parent);
		}
	}(vm);
	return {
		[name]: store
	};
}

function mapStore(name, data) {
	if (typeof name != 'string') {
		data = name;
		name = 'store';
	}

	const res = {};
	if (data.constructor == Array) {
		data.forEach(key => {
			res[key] = {
				get() {
					try {
						return this[name][key];
					} catch(e) {
						return undefined;
					}
				},
				set() {}
			}
		});
	} else {
		for(let key in data) {
			res[key] = {
				get() {
					return data[key](this[name]);
				},
				set() {}
			}
		}
	}
	return res;
}

export {createStore, getStore, mapStore}